import React from "react";

const infoSvg = () => {
  return <svg xmlns="http://www.w3.org/2000/svg" data-name="Layer 1" viewBox="0 0 29 29" id="info"><path d="M16.837 19.198h-.753v-6.01a1 1 0 0 0-1-1h-2.92a1 1 0 0 0 0 2h1.92v5.01h-1.92a1 1 0 1 0 0 2h4.673a1 1 0 1 0 0-2ZM14.5 10.013a1.5 1.5 0 1 0-1.5-1.5 1.5 1.5 0 0 0 1.5 1.5ZM14.5 2A12.514 12.514 0 0 0 2 14.5 12.521 12.521 0 0 0 14.5 27a12.5 12.5 0 0 0 0-25Zm7.33 20.006A10.491 10.491 0 1 1 25 14.5a10.411 10.411 0 0 1-3.17 7.506Z"></path></svg>
}

export default infoSvg;